import { render, staticRenderFns } from "./registerLogin.vue?vue&type=template&id=44715467&scoped=true"
import script from "./registerLogin.vue?vue&type=script&lang=js"
export * from "./registerLogin.vue?vue&type=script&lang=js"
import style0 from "./registerLogin.vue?vue&type=style&index=0&id=44715467&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44715467",
  null
  
)

export default component.exports